import { connect } from 'react-redux'
import { isImageLoaded } from './selectors'
import {
  addImageAction,
  setupImageAction,
} from './actions'

import AsyncImage from './AsyncImageComponent'

// ownProps must contain: src
// ownProps may contain: alt, className

const mapStateToProps = (state, ownProps) => ({
  loaded: isImageLoaded(state, ownProps),
})

export default connect(
  mapStateToProps,
  {
    beginImageLoad: addImageAction,
    onImageLoad: setupImageAction,
  }
)(AsyncImage)



// WEBPACK FOOTER //
// ./src/asyncImages/AsyncImage.js